import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {GroupItem} from './GroupItem';
import {withTranslation} from 'react-i18next';

const Groups = ({t, menuGroups, visibleSection, setVisibleSection, menuItems, menuPresentation, branchInfo}) => {
  const hasMenuItems = (group) => {
    return menuItems.filter(i => i.parentId === group.menu_item_id).length > 0;
  };

  return (
    <>
      <div className="nav-side-menu group-list">

        {/*<h3 className="headline"><span>{t('menu.title')}</span></h3>*/}

        <div className="menu-list">

          <ul id={ 'menu-groups-list' } className="menu-content">
            {
              menuGroups.filter(g => hasMenuItems(g)).map(group => (
                <GroupItem groupItem={ group } visibleSection={ visibleSection }  setVisibleSection={setVisibleSection} menuPresentation={ menuPresentation } branchInfo={ branchInfo } />
              ))
            }
          </ul>
        </div>
      </div>

    </>
  );
};

const mapStateToProps = (state) => {
  const {
    menuGroups,
    menuItems,
    menuPresentation,
    branchInfo
  } = state;

  return {
    menuGroups,
    menuItems,
    menuPresentation,
    branchInfo
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {},
    dispatch,
  );

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Groups));

